import React from "react";
import { TrendingUp, Building2, Tv, Briefcase, Sparkles } from "lucide-react";
import "./ProgramDetails.custom.css";

const highlights = [
  {
    id: 1,
    value: "54%",
    label: "Average Salary Hike",
    icon: <TrendingUp className="w-6 h-6 text-green-500" />,
    gradient: "from-green-500/10 to-emerald-500/5",
    border: "hover:border-green-500/30",
  },
  {
    id: 2,
    value: "150+",
    label: "Top Hiring Partners",
    icon: <Building2 className="w-6 h-6 text-blue-500" />,
    gradient: "from-blue-500/10 to-indigo-500/5",
    border: "hover:border-blue-500/30",
  },
  {
    id: 3,
    value: "100+",
    label: "Live Mentoring Hours",
    icon: <Tv className="w-6 h-6 text-purple-500" />,
    gradient: "from-purple-500/10 to-pink-500/5",
    border: "hover:border-purple-500/30",
  },
  {
    id: 4,
    value: "98%",
    label: "Job Placement Rate",
    icon: <Briefcase className="w-6 h-6 text-amber-500" />,
    gradient: "from-amber-500/10 to-orange-500/5",
    border: "hover:border-amber-500/30",
  },
];

const ProgramCohortHighlights = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-center mb-12 max-w-3xl mx-auto">
        <span className="pd-badge mb-4 mx-auto">
          <Sparkles size={11} className="text-blue-500 animate-pulse" />
          Cohort Impact
        </span>
        <h2 className="text-4xl font-extrabold text-gray-900 tracking-tight leading-none mt-2">
          Key Program Highlights
        </h2>
        <p className="text-gray-500 text-sm mt-4 leading-relaxed">
          See how our learners accelerate their career growth, build practical capabilities, and unlock new industry opportunities.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {highlights.map((item) => (
          <div
            key={item.id}
            className={`relative bg-white border border-gray-100 rounded-3xl p-8 shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl ${item.border} group`}
            style={{ transformStyle: "preserve-3d" }}
          >
            {/* Background Accent glow */}
            <div className={`absolute inset-0 bg-gradient-to-br ${item.gradient} rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none`} />
            
            <div className="relative z-10 flex flex-col items-center text-center">
              <div className="p-4 bg-gray-50 rounded-2xl group-hover:bg-white group-hover:scale-110 group-hover:shadow-md transition-all duration-300 mb-6">
                {item.icon}
              </div>
              <span className="text-4xl font-black text-gray-900 tracking-tight mb-2 block group-hover:scale-105 transition-transform duration-300">
                {item.value}
              </span>
              <p className="text-sm font-bold text-gray-500 uppercase tracking-wider group-hover:text-gray-800 transition-colors duration-300">
                {item.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCohortHighlights;
